import { render, staticRenderFns } from "./PageSubtitle.vue?vue&type=template&id=67ee08da&scoped=true&"
import script from "./PageSubtitle.vue?vue&type=script&lang=js&"
export * from "./PageSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./PageSubtitle.vue?vue&type=style&index=0&id=67ee08da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee08da",
  null
  
)

export default component.exports